import { h } from 'preact'
import { Item } from './types'

const ListItem = ({ item, onClick } : { item: Item, onClick: (item: Item) => void }) =>
  <div class='list-item' onClick={() => onClick(item)}>
    <div>{item.title}</div>
  </div>

const List = ({ items, onClick }: { items: Item[], onClick: (item: Item) => void }) =>
  <div class='list'>
    { items.map((item: Item) => <ListItem item={item} onClick={onClick} />) }
  </div>

export default List
